import React from 'react';
import moment from 'moment';

const CallLogMessage = ({ callLog, user }) => {
    const isCaller = callLog.caller._id === user._id || callLog.caller === user._id;

    const formatDuration = (seconds) => {
        if (!seconds || seconds === 0) return '';
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    };

    const getCallIcon = () => {
        const iconStyle = { marginRight: '4px', fontSize: '12px' };
        if (callLog.callType === 'video') {
            return <i className="fa fa-video-camera" style={iconStyle}></i>;
        }
        return <i className="fa fa-phone" style={iconStyle}></i>;
    };

    const getCallText = () => {
        if (callLog.status === 'missed') {
            return isCaller ? 'Missed call' : 'Missed call from you';
        }
        if (callLog.status === 'declined') {
            return isCaller ? 'Call declined' : 'You declined the call';
        }
        if (callLog.status === 'answered') {
            const callTypeText = callLog.callType === 'video' ? 'Video call' : 'Audio call';
            const duration = formatDuration(callLog.duration);
            return duration ? `${callTypeText} (${duration})` : callTypeText;
        }
        return 'Call';
    };

    const getCallColor = () => {
        if (callLog.status === 'missed') return '#ff6b6b';
        if (callLog.status === 'declined') return '#ff8787';
        return '#51cf66';
    };

    return (
        <div style={{
            display: 'flex',
            justifyContent: isCaller ? 'flex-end' : 'flex-start',
            margin: '6px 0'
        }}>
            <div style={{
                backgroundColor: isCaller ? '#00695c' : '#e8eaed',
                color: isCaller ? '#fff' : '#1c1e21',
                padding: '6px 10px',
                borderRadius: '12px',
                maxWidth: '240px',
                border: `1.5px solid ${getCallColor()}`,
                fontSize: '13px'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    {getCallIcon()}
                    <span>{getCallText()}</span>
                </div>
                <div style={{ fontSize: '10px', marginTop: '2px', opacity: 0.75 }}>
                    {moment(callLog.createdAt).format('HH:mm')}
                </div>
            </div>
        </div>
    );
};

export default CallLogMessage;
